<template>
  <div class="questionnaire">
    <div class="questionnaire-left">
      <form @submit.prevent="validateBeforeSubmit" action="/anket-submit" id="anket-form" method="POST">
        <input type="hidden" name="_token" :value="token">
        <div class="questionnaire-block">
          <h3 class="questionnaire__ttl">Поділіться з нами планами своєї подорожі</h3>
          <div class="form-group">
            <input type="hidden" name="multiselectObj" v-validate="'required'"
                   :value='JSON.stringify(observeObj.multiselectObj)'>
            <!--<input type="hidden" name="multiselectObj" v-model="observeObj.multiselectObj">-->
            <multiselect v-model="observeObj.multiselectObj" :options="multiselectOptions" return="id"
                         :multiple="true"
                         track-by="id" :custom-label="customLabel" class="multiselect-country" :max="3"
                         name="destination"
                         placeholder="Оберіть напрямок …" :close-on-select="true" v-validate="'required'"
                         :class="{'error': errors.has('destination')}">
            </multiselect>
            <label v-show="errors.has('destination')" class="help error">Поле обов'язкове</label>
          </div>
          <h4 class="questionnaire__ttl1">Введіть напрямок або виберіть з популярних напрямків:</h4>
          <div class="tag-list mb-20">
            <div class="tag__item" v-for="(item, index) in popularCountries" :key="index"
                 @click.prevent="changeCountry(item)">{{item.name}}
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <label for="" class="lbl">Дата відправлення</label>
              <div class="form-group datepicker-group icon-calendar">
                <datepicker v-model="observeObj.dateOfDeparture" :value="state.date"
                            :disabledDates="state.disabledDates" :language="state.uk"
                            name="departure_date" :input-class="{'error': errors.has('departure_date')}"
                            placeholder="dd/mm/yyyy" v-validate="'required'">
                </datepicker>
                <label v-show="errors.has('departure_date')" class="help error">Поле обов'язкове</label>
              </div>
            </div>
            <div class="col-lg-4">
              <label for="" class="lbl">Дні перебування</label>
              <div class="form-group select-group">
                <select class="form-control" v-model="observeObj.daysOfStay" name="days"
                        v-validate="'required'">
                  <option value="1 - 8 ночей" selected="selected">на 1 - 8 ночей</option>
                  <option value="8 - 12 ночей">на 8 - 12 ночей</option>
                  <option value="12 - 22 ночей">на 12 - 22 ночей</option>
                  <option value="22 - 41 ночей">на 22 - 41 ночей</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- questionnaire-block -->
        <div class="questionnaire-block">
          <h3 class="questionnaire__ttl">Ваші дані</h3>
          <div class="row row-sm mb-20">
            <div class="col-lg-4">
              <div class="form-group">
                <input type="text" name="name" v-model="name" v-validate="'required'" placeholder="Ім’я"
                       :class="{'form-control': true, 'error': errors.has('name') }">
                <label v-show="errors.has('name')" class="help error">{{ errors.first('name') }}</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <input type="email" v-validate="'required|email'" name="email" v-model="email"
                       placeholder="Email"
                       :class="{'form-control': true, 'error': errors.has('email') }">
                <label v-show="errors.has('email')" class="help error">{{ errors.first('email')
                  }}</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <input type="phone"
                       v-validate="'required|length:19'"
                       class="input-phone"
                       name="phone"
                       placeholder="Телефон"
                       v-model.lazy="phone"
                       v-mask="'+38 (0##) ###-##-##'"
                       :class="{'form-control': true,  'error': errors.has('phone') }">
                <label v-show="errors.has('phone')"
                       class="help error">
                    {{ errors.first('phone') }}
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="chk-wr">
                <input type="checkbox" class="chk" id="chk-000" name="include_newsletter">
                <label for="chk-000">Хочу отримувати ексклюзивні пропозиції від Пілігрим</label>
              </div>
            </div>
          </div>
        </div>
        <!-- questionnaire-block -->
        <div class="questionnaire-block">
          <h3 class="questionnaire__ttl">Хто подорожує?</h3>
          <div class="row row-sm mb-20">
            <div class="col-lg-3">
              <div class="form-group select-group select-group__label">
                <label for="adults">Дорослі:</label>
                <select class="form-control" v-model="observeObj.countAdults" name="adults" id="adults"
                        v-validate="'required'">
                  <option value="1">1</option>
                  <option value="2" selected="selected">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group select-group select-group__label">
                <label for="child">Діти:</label>
                <select class="form-control child-sel" v-model="observeObj.countChild" name="child"
                        id="child"
                        v-validate="'required'">
                  <option value="0" selected="selected">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                </select>
              </div>
            </div>
          </div>
          <h4 class="questionnaire__ttl1">Чи це особлива подія?</h4>
          <div class="radio-group mb-20">
            <div class="rad-wr">
              <input type="radio" name="event" value="none" class="rad" id="rad-001" checked="checked">
              <label for="rad-001">Ні</label>
            </div>
            <div class="rad-wr">
              <input type="radio" name="event" value="honey_moon" class="rad" id="rad-002">
              <label for="rad-002">Медовий місяць</label>
            </div>
            <div class="rad-wr">
              <input type="radio" name="event" value="anniversary" class="rad" id="rad-003">
              <label for="rad-003">Річниця</label>
            </div>
            <div class="rad-wr">
              <input type="radio" name="event" value="birthday" class="rad" id="rad-004">
              <label for="rad-004">День народження</label>
            </div>
            <div class="rad-wr">
              <input type="radio" name="event" value="another" class="rad" id="rad-005">
              <label for="rad-005">Інше</label>
            </div>
          </div>
          <!-- radio-group -->
          <h4 class="questionnaire__ttl1">Чи вже подорожували разом з Пілігрим?</h4>
          <div class="radio-group">
            <div class="rad-wr">
              <input type="radio" name="old_client" value="0" class="rad" id="rad-010">
              <label for="rad-010">Так</label>
            </div>
            <div class="rad-wr">
              <input type="radio" name="old_client" value="1" class="rad" id="rad-011" checked="checked">
              <label for="rad-011">Ні</label>
            </div>
          </div>
        </div>
        <!-- questionnaire-block -->
        <div class="questionnaire-block">
          <h3 class="questionnaire__ttl">Готель та літак</h3>
          <h4 class="questionnaire__ttl1">Категорія готелю</h4>
          <div class="chk-group mb-20">
            <div class="chk-wr">
              <input type="checkbox" class="chk" id="chk-010" name="two_stars"
                     v-on:click="checkDisabled" >
              <label for="chk-010">
                <i class="icon-star" v-for="n in 2"><span class="path1"></span><span class="path2"></span></i>
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
              </label>
            </div>
            <div class="chk-wr">
              <input type="checkbox" class="chk" id="chk-011" name="three_stars"
                     v-on:click="checkDisabled" >
              <label for="chk-011">
                <i class="icon-star" v-for="n in 3"><span class="path1"></span><span class="path2"></span></i>
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
              </label>
            </div>
            <div class="chk-wr">
              <input type="checkbox" class="chk" id="chk-012" name="four_stars"
                     v-on:click="checkDisabled" >
              <label for="chk-012">
                <i class="icon-star" v-for="n in 4"><span class="path1"></span><span class="path2"></span></i>
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
              </label>
            </div>
            <div class="chk-wr">
              <input type="checkbox" class="chk" id="chk-013" name="five_stars"
                     v-on:click="checkDisabled" >
              <label for="chk-013">
                <i class="icon-star" v-for="n in 5"><span class="path1"></span><span class="path2"></span></i>
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
                <!--<i class="icon-star"><span class="path1"></span><span class="path2"></span></i>-->
              </label>
            </div>

          </div>
          <!-- chk-list -->
          <h4 class="questionnaire__ttl1">Аеропорт відправлення</h4>
          <div class="chk-group">
            <div class="chk-wr">
              <input type="checkbox" class="chk" id="chk-020" name="without_fly">
              <label for="chk-020">Без перельоту</label>
            </div>
            <div class="chk-wr">
              <input type="checkbox" class="chk" id="chk-021" name="fly_from_ukraine">
              <label for="chk-021">Виліт з України</label>
            </div>
            <div class="chk-wr">
              <input type="checkbox" class="chk" id="chk-022" name="fly_from_poland">
              <label for="chk-022">Виліт з Польщі</label>
            </div>
          </div>
          <!-- chk-list -->

        </div>
        <!-- questionnaire-block -->
        <div class="questionnaire-block">
          <h3 class="questionnaire__ttl">Як можна з Вами зв’ язатись?</h3>
          <div class="row mb-20">
            <div class="col">
              <div class="rad-wr">
                <input v-model="contact_rad" v-validate="'required|included:0,1,2'" type="radio"
                       name="contact" class="rad" id="rad-020" checked="checked" value="0">
                <label for="rad-020">Зателефонуйте мені</label>
              </div>
              <div class="rad-wr">
                <input v-model="contact_rad" type="radio" name="contact" class="rad" id="rad-021"
                       value="1">
                <label for="rad-021">Через ел.пошту</label>
              </div>
              <div class="rad-wr">
                <input v-model="contact_rad" type="radio" name="contact" class="rad" id="rad-022"
                       value="2">
                <label for="rad-022">Зустріч в одному з наших офісів (Львів, вул.Коперника 26 або
                  вул.Зелена 39)</label>
              </div>
              <label class="help error" v-show="errors.has('contact')">Поле обов'язкове</label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label for="comment" class="lbl">Додати коментар</label>
              <textarea name="comment" id="comment" class="form-control"
                        placeholder="Оберіть локацію ..."></textarea>
            </div>
          </div>
          <div class="btn-group text-center">
            <input type="submit" value="Надіслати запит" class="btn btn-primary btn-primary__inline">
          </div>
        </div>
        <!-- questionnaire-block -->
      </form>
    </div>
    <!-- questionnaire-left -->
    <div class="questionnaire-right">
      <div class="enquiry hidden-xs hidden">
        <h3 class="enquiry__ttl">Мій запит</h3>
        <div class="enquiry-container">
          <div class="enquiry-group">
            <div class="enquiry-item">
              <div class="enquiry-item__label">ПРИЗНАЧЕННЯ</div>
              <div class="enquiry-item__data">
                <span v-if="!observeObj.multiselectObj.length">Не Вибрано</span>
                <span v-else v-for="(item,index) in observeObj.multiselectObj" :key="index">
									<span v-if="index > 0">, </span>{{item.country}} </span>
              </div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Дата</div>
              <div class="enquiry-item__data">
                <span v-if="!formatDate">Не Вибрана</span>
                <span v-else>{{formatDate}}</span>
              </div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Тривалість</div>
              <div class="enquiry-item__data">{{observeObj.daysOfStay}}</div>
            </div>
          </div>
          <!-- enquiry-group -->
          <div class="enquiry-group">
            <div class="enquiry-item">
              <div class="enquiry-item__label">Дорослі</div>
              <div class="enquiry-item__data">{{observeObj.countAdults}}</div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Діти</div>
              <div class="enquiry-item__data">{{observeObj.countChild}}</div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Випадковість</div>
              <div class="enquiry-item__data">Ні</div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Piligrime раніше</div>
              <div class="enquiry-item__data">Немає</div>
            </div>
          </div>
          <!-- enquiry-group -->
          <div class="enquiry-group">
            <div class="enquiry-item">
              <div class="enquiry-item__label">Зіркові відгуки</div>
              <div class="enquiry-item__data">Від 3 до 5 зірок</div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Виліт аеропорту</div>
              <div class="enquiry-item__data">Будь-який аеропорт у Великобританії</div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Клас польоту</div>
              <div class="enquiry-item__data">Немає</div>
            </div>
            <div class="enquiry-item">
              <div class="enquiry-item__label">Інше</div>
              <div class="enquiry-item__data">Немає</div>
            </div>
          </div>
          <!-- enquiry-group -->
          <div class="enquiry-group">
            <div class="enquiry-item">
              <div class="enquiry-item__label">Подробиці</div>
              <div class="enquiry-item__data"></div>
            </div>
          </div>
          <!-- enquiry-group -->
          <div class="enquiry-group">
            <div class="enquiry-item">
              <div class="enquiry-item__label">Зворотній зв'язок</div>
              <div class="enquiry-item__data">по електронній пошті</div>
            </div>
          </div>
          <div class="enquiry-group">
            <button class="btn btn-primary" type="submit">Надіслати запит</button>
          </div>
          <!-- enquiry-group -->
        </div>
        <!-- enquiry-container -->
      </div>
      <!-- enquiry -->

      <slot name="infoBlock"></slot>
    </div>
    <!-- questionnaire-right -->
  </div>
  <!-- questionnaire -->
</template>

<script>

	// const focus = {
	// 	inserted(el) {
	// 		el.focus()
	// 	},
	// }

    import multiselect from "vue-multiselect";
    import datepicker from "vuejs-datepicker";
    import {en, uk} from "vuejs-datepicker/dist/locale";
    import ukraine from 'vee-validate/dist/locale/uk';

    import {TheMask, mask} from 'vue-the-mask';

    export default {
        props: ["token"],
        components: {
            multiselect,
            datepicker,
            TheMask
        },
        directives: {
        	mask,
	        focus
        },
        data() {
            return {
                observeObj: {
                    multiselectObj: [],
                    daysOfStay: "8 - 12 ночей",
                    dateOfDeparture: null,
                    countAdults: 2,
                    countChild: 0
                },
                email: "",
                phone: "",
                // phone: "",
                name: "",
                contact_rad: "",
                checkedList: [],
                checkedRatings: [],
                ratingCounter: 2,
                state: {
                    date: new Date(),
                    disabledDates: {
                        to: ""
                    },
                    uk: uk,
                    en: en
                },
                multiselectOptions: [
                    {country: "Мальдіви"},
                    {country: "Тайланд"},
                    {country: "Індія"},
                    {country: "Кенія"},
                    {country: "Шрі Ланка"},
                    {country: "США"}
                ],
                popularCountries: [
                    {country: "Україна"},
                    {country: "Карпати"},
                    {country: "Індія"},
                    {country: "Кенія"},
                    {country: "Шрі Ланка"},
                    {country: "США"}
                ]
            };
        },
        created() {
            this.changeDate();

            this.$validator.localize('uk', {
                messages: ukraine.messages
            });

            this.$validator.localize('uk');
        },
        computed: {
            formatDate() {
                if (this.observeObj.dateOfDeparture) {
                    let date = new Date(this.observeObj.dateOfDeparture);
                    var day = date.getDate();
                    if (day < 10) day = "0" + day;

                    var month = date.getMonth() + 1;
                    if (month < 10) month = "0" + month;

                    var year = date.getFullYear() % 100;
                    if (year < 10) year = "0" + year;

                    return day + "." + month + "." + year;
                }
            }
        },
        mounted() {
            axios.post('countries-for-header').then(response => {
                this.multiselectOptions = response.data;
            });
            axios.post('countries-popular').then(response => {
                this.popularCountries = response.data;
            });

        },
        methods: {
        	// removePlaceholder(e) {
		    //     console.log(e);
            //     if(this.phone.length < 3) {
	        //         this.phone = "+380"
            //     }
	        // },
            changeDate() {
                let date = new Date();
                date.setDate(date.getDate() + 6);

                this.state.disabledDates.to = date;
            },
            checkDisabled(e) {

                let checkedName = e.currentTarget.name;
                this.checkedList.push(checkedName);

                let ratingsList = [
                    'two_stars',
                    'three_stars',
                    'four_stars',
                    'five_stars'
                ];

                let checkedIndex = ratingsList.indexOf(checkedName);
                let clause = false;

                if (e.currentTarget.checked) {
                    $('#anket-form .chk-group.mb-20>div>input').each(function (i, val) {
                        if (checkedIndex < ratingsList.length - 1) {
                            clause = i === checkedIndex + 1 || i === checkedIndex;
                        }
                        else {
                            clause = i === checkedIndex  || i === checkedIndex - 1;
                        }
                        $(val).prop('checked', clause);
                    });
                } else {
                    $('#anket-form .chk-group.mb-20>div').each(function (i, val) {
                        let tmpInput = $(val).children('input');
                        tmpInput[0].disabled = false;
                    });
                }
            },
            customLabel(option) {
                return `${option.name}`;
            },
            changeCountry(el) {
                let newArray = this.observeObj.multiselectObj;
                let flag = true;
                newArray.forEach((item, index) => {
                    if (item.id === el.id) {
                        this.observeObj.multiselectObj.splice(index, 1);
                        flag = false;
                        return true;
                    }
                });

                if (flag && newArray.length < 3) {
                    this.observeObj.multiselectObj.push(el);
                }
            },
            maskPhone() {
                let cleave = new Cleave('.input-phone', {
                    phone: true,
                    phoneRegionCode: 'UA',
                    prefix: '+38',
                    numericOnly: true
                });
            },
            validateBeforeSubmit() {
                this.$validator.validateAll().then(result => {
                    console.log(result);
                    if (result) {
                        var $anket = $('#anket-form');
                        var values = {};

                        $.each($anket.serializeArray(), function (i, field) {
                            values[field.name] = field.value;
                            $("[name =" + field.name + "]").removeClass("error");
                            $("[name =" + field.name + "]").parent().find('.error').remove()
                        });

                        let url = $anket.attr('action');

                        fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(values)
                        })
                            .then(res => {
                                if (res.errors) {
                                    res.errors.forEach((error, i) => {
                                        $("[name =" + index + "]").addClass("error");
                                        $("[name =" + index + "]").parent().append('<label class="error">' + error + '</label>');
                                    });
                                }
                                else {
                                    document.getElementById("anket-form").submit();
                                }
                            })
                            .catch(err => console.error(err));

                        return;
                    }
                    let fieldName = this.errors.items[0].field;
                    $('html, body').animate({
                        scrollTop: ($(`[name=${fieldName}]`).offset().top-50)
                    },500);
                    console.error("Correct them errors!");
                });
            }
        }
    };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect-country .multiselect__tags {
    border-radius: 0;
    border-color: #979797;
    min-height: 42px;
    padding: 10px 40px 0 17px;
    color: #505050;
    font: 15px/1.1333 "Ubuntu", sans-serif;
  }

  .multiselect-country .multiselect__tag {
    background: #ffffff;
    color: #212121;
    padding-right: 25px;
    margin-right: 5px;
  }

  .multiselect-country .multiselect__tag-icon {
    top: 2px;
  }

  .multiselect-country .multiselect__tag-icon:hover {
    background: #0083b7;
  }

  .multiselect-country .multiselect__tag-icon:hover:after {
    color: #fff;
  }

  .multiselect-country .multiselect__tag-icon:after {
    color: #0083b7;
    font-size: 20px;
  }

  .multiselect-country .multiselect__tags .multiselect__input {
    margin-top: 2px;
  }

  .datepicker-group input {
    height: 42px;
    padding: 8px 17px 8px 33px;
    color: #505050;
    font: 15px/1.1333 "Ubuntu", sans-serif;
    border: solid 1px #979797;
    background: transparent;
    display: block;
    width: 100%;
  }

  .multiselect__element span:before,
  .multiselect__element span:after {
    display: none !important;
  }

  .multiselect.error > .multiselect__tags {
    border-color: #f00;
  }

  .datepicker-group {
    position: relative;
  }

  .datepicker-group:before {
    z-index: 0;
    position: absolute;
    left: 10px;
    top: 11px;
    font-size: 19px;
    line-height: 1;
  }

  .select-group:after {
    right: 8px;
  }

  .hidden {
    display: none !important;
  }

  input.error {
    border-color: red;
  }

  span.error {
    color: red;
    font-size: 13px;
    line-height: 1.2;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Anket.vue